<div class="text-center w-100 h-100" #dynamicTextContainer >

    <div >
        <div class="pl-5 pr-5">
            <div  [ngStyle]="getStyle()" >
                {{inject.value}}
            </div>
        </div>
    </div>

</div>